import React, { useMemo } from "react";
import Dropdown, { DropdownOption } from "./Dropdown";

interface YearDropdownProps {
  year: number | null;
  onChange: (value: DropdownOption | null) => void;
  placeholder?: string;
  className?: string;
  yearsOffset?: number;
}

const YearDropdown: React.FC<YearDropdownProps> = ({
  year,
  onChange,
  placeholder = "Select Year",
  yearsOffset = 3,
  className,
}) => {
  const YEAR_OPTIONS: DropdownOption[] = useMemo(
    () =>
      Array.from({ length: yearsOffset }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { name: year.toString(), code: year };
      }),
    [yearsOffset]
  );

  const value = YEAR_OPTIONS.find((y) => y.code === year);

  return (
    <Dropdown
      options={YEAR_OPTIONS}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default YearDropdown;
